import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'guardian/api';

export const types = {
  FETCH_MEMBERS: 'MEMBERS/FETCH',
  FETCH_MEMBERS_SUCCESS: 'MEMBERS/FETCH_SUCCESS',
  FETCH_MEMBERS_FAILURE: 'MEMBERS/FETCH_FAILURE',
  CHANGE_ROLE: 'MEMBERS/CHANGE_ROLE',
  CHANGE_ROLE_SUCCESS: 'MEMBERS/CHANGE_ROLE_SUCCESS',
  CHANGE_ROLE_FAILURE: 'MEMBERS/CHANGE_ROLE_FAILURE',
  CLEAR_ERROR: 'MEMBERS/CLEAR_ERROR',
};

export const actions = {
  fetchMembers: () => ({ type: types.FETCH_MEMBERS }),
  changeRole: (userId, role) => ({ type: types.CHANGE_ROLE, userId, role }),
  clearError: () => ({ type: types.CLEAR_ERROR }),
};

const initialState = {
  isLoading: false,
  items: [],
  error: null,
  pendingUserId: null,
};

export default function membersReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MEMBERS:
      return { ...state, isLoading: true, error: null };
    case types.FETCH_MEMBERS_SUCCESS:
      return { ...state, isLoading: false, items: action.items };
    case types.FETCH_MEMBERS_FAILURE:
      return { ...state, isLoading: false, error: action.error };

    case types.CHANGE_ROLE:
      return { ...state, pendingUserId: action.userId, error: null };
    case types.CHANGE_ROLE_SUCCESS: {
      const items = state.items.map((m) =>
        m.user_id === action.data.user_id ? { ...m, ...action.data } : m
      );
      return { ...state, pendingUserId: null, items };
    }
    case types.CHANGE_ROLE_FAILURE:
      return { ...state, pendingUserId: null, error: action.error };

    case types.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
}

const errMsg = (e, fallback) =>
  e.response?.data?.error || e.response?.data?.detail || fallback;

function* fetchMembersSaga() {
  try {
    const res = yield call(api.get, '/api/v1/account/members/');
    yield put({
      type: types.FETCH_MEMBERS_SUCCESS,
      items: res.data.results || [],
    });
  } catch (e) {
    yield put({
      type: types.FETCH_MEMBERS_FAILURE,
      error: errMsg(e, 'Failed to load members'),
    });
  }
}

function* changeRoleSaga(action) {
  try {
    const res = yield call(
      api.patch,
      `/api/v1/account/members/${action.userId}/`,
      { role: action.role }
    );
    yield put({ type: types.CHANGE_ROLE_SUCCESS, data: res.data });
  } catch (e) {
    yield put({
      type: types.CHANGE_ROLE_FAILURE,
      error: errMsg(e, 'Failed to change role'),
    });
  }
}

export function* membersSagas() {
  yield takeLatest(types.FETCH_MEMBERS, fetchMembersSaga);
  yield takeLatest(types.CHANGE_ROLE, changeRoleSaga);
}
